// -----------------------------------------------------------------------
// <copyright file='EnvironmentConfig.ts' company='Microsoft'>
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export enum GetHelpBaseUrl {
  Prod = 'https://concierge.live.com',
  PPE = 'https://osefo.live.com',
  Dev = 'https://supportdev.office.com',
  Local = 'http://localhost:9000',
}

export type EnvironmentConfig = {
  baseUrl: GetHelpBaseUrl;
  smcAuthUrlBase: string;
  emsAuthUrlBase: string;
  emsApplicationId: string;
  raveWidgetUrl: string;
  ecsConfigUrl: string;
  alchemyAutoSuggestApiUrl: string;
};

export const prodEnvironment: EnvironmentConfig = {
  baseUrl: GetHelpBaseUrl.Prod,
  smcAuthUrlBase: 'support.microsoft.com',
  emsAuthUrlBase: 'prod.emerald.microsoft.com',
  emsApplicationId: '59929c62-edde-413a-b308-a5057f3d1cb5',
  raveWidgetUrl: 'https://widget.rave.office.net/',
  ecsConfigUrl: 'https://config.edge.skype.com/',
  alchemyAutoSuggestApiUrl: 'alchemysage.azurefd.net',
};

export const ppeEnvironment: EnvironmentConfig = {
  baseUrl: GetHelpBaseUrl.PPE,
  smcAuthUrlBase: 'support.microsoft.com',
  emsAuthUrlBase: 'ppe.emerald.microsoft.com',
  emsApplicationId: '596e4b8a-3477-4561-ab9f-a8e41d6cf6a4',
  raveWidgetUrl: 'https://widget.rave.office.net/',
  ecsConfigUrl: 'https://config.edge.skype.net/',
  alchemyAutoSuggestApiUrl: 'alchemysage.azurefd.net',
};

export const devEnvironment: EnvironmentConfig = {
  baseUrl: GetHelpBaseUrl.Dev,
  smcAuthUrlBase: 'support.microsoft.com',
  emsAuthUrlBase: 'ppe.emerald.microsoft.com',
  emsApplicationId: '596e4b8a-3477-4561-ab9f-a8e41d6cf6a4',
  raveWidgetUrl: 'https://widget.rave.office.net/',
  ecsConfigUrl: 'https://config.edge.skype.net/',
  alchemyAutoSuggestApiUrl: 'alchemysage.azurefd.net',
};
